module.exports = __webpack_public_path__ + "media/images/sp/stores/asakusa/asakusa_concept_01-33959fc26d99f93f2ca5cc52f74ef14f.jpg";